export const actionLogStatus = {
  CREATION: 'Criada',
  ANSWERED: 'Respondida',
  CLOSURE: 'Finalizada',
  ERROR: 'Erro',
  UPDATE: 'Atualizada',
};
